<template>
  <div class="row">
    <div class="col-12">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle text-center">ESTADO</th>
            <th scope="col" class="align-middle text-center">CODIGO</th>
            <th scope="col" class="align-middle text-center">
              PLANIFICADO DESDE
            </th>
            <th scope="col" class="align-middle text-center">
              PLANIFICADO HASTA
            </th>
            <th scope="col" class="text-center" style="width: 10%"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in evaluations" :key="i">
            <td class="align-middle">{{ v.status.name }}</td>
            <td class="align-middle text-center">{{ v.code }}</td>
            <td class="align-middle text-center">
              {{ v.date_start | dateFormat }}
            </td>
            <td class="align-middle text-center">
              {{ v.date_end | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openModal(v.id)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <historical-eval-test-modal
      v-if="isModalActive"
      :eval-test-id="evalTestId"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  data() {
    return {
      evaluations: [],
      isModalActive: false,
      evalTestId: null,
    };
  },
  created() {
    this.$hub.$on("reload-table", () => {
      this.getData();
    });
    this.getData();
  },
  filters: {
    dateFormat: function (value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
    },
  },
  methods: {
    getData() {
      this.preloader = true;
      let url = `/historical/accreditation/${this.$store.state.common.accAppId}/evalTest?type=T`;
      axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.evaluations = response.data.evaluations;
            this.$store.state.common.accApp = response.data.accApp;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    openModal(evalTestId) {
      this.evalTestId = evalTestId;
      this.isModalActive = true;
    },

    closeModal() {
      this.isModalActive = false;
    },
  },
};
</script>